<template>
    <div :id="id" :class="prefixCls">
        <slot></slot>
    </div>
</template>

<script>
    import {GoingUtils} from "goingutils";

    export default {
        name: "go-layout-panel",
        data: function () {
            return {
                show: true,
                id: GoingUtils.getUUid(12),
                prefixCls: "go-layout-panel"
            };
        },
        beforeDestroy(){
            $("#"+this.id).remove();
        },
        props:{
            searchFun:{},
            searchFieldAry:{type:[Array,Object],default:()=>[]}
        },
        methods: {},
        mounted() {
        },
        components: {}
    };
</script>



// WEBPACK FOOTER //
// goingsrc/vueCom/layoutVue/go-layout-panel.vue